const CoffeeLocactions = () => {
    return(
        <>
        <h1 className="center">Coffee Shop Locations</h1>
        <div className="locations">
            <div className="imgs">
                <div className="loc1"><h1>Hyderabad</h1></div>
                <div className="loc2"><h1>Lucknow</h1></div>
                <div className="loc3"><h1>Jaipur</h1></div>
                <div className="loc4"><h1>Delhi</h1></div>
                <div className="loc5"><h1>Kolkata</h1></div>
                <div className="loc6"><h1>Goa</h1></div>
            </div>
            <div className="map">
                <img src="images/map.jpg" alt="" />
            </div>
           
        </div>
        </>
    )
};

export default CoffeeLocactions;
